import { render } from "./Assistant.vue?vue&type=template&id=15888c23&scoped=true"
import script from "./Assistant.vue?vue&type=script&lang=js"
export * from "./Assistant.vue?vue&type=script&lang=js"

import "./Assistant.vue?vue&type=style&index=0&id=15888c23&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15888c23"]])

export default __exports__